import React, { useEffect, useState } from "react";
import { Bell, BellRing, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { currentSubscription, enablePush, isIOS, isStandalone, pushSupported } from "../../lib/pwa";

export const ChatPushButton = () => {
  const [state, setState] = useState("checking");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!pushSupported()) { setState(isIOS() && !isStandalone() ? "ios-install" : "unsupported"); return; }
    currentSubscription().then((s) => setState(s && Notification.permission === "granted" ? "on" : "off")).catch(() => setState("off"));
  }, []);

  const enable = async () => {
    setBusy(true);
    try { await enablePush(); setState("on"); toast.success("Notifiche attive: riceverai un avviso per ogni nuovo messaggio"); }
    catch (e) { toast.error(e.message || "Impossibile attivare le notifiche"); }
    finally { setBusy(false); }
  };

  if (state === "checking" || state === "unsupported") return null;
  if (state === "on") {
    return <div className="text-[11px] flex items-center gap-1 px-3 py-1.5" style={{ color: "#1B5E20" }} data-testid="chat-push-on"><BellRing className="w-3.5 h-3.5" /> Notifiche attive su questo dispositivo</div>;
  }
  if (state === "ios-install") {
    return <div className="text-[11px] px-3 py-1.5" style={{ color: "var(--text-muted)" }} data-testid="chat-push-ios">Per le notifiche su iPhone: Condividi → Aggiungi a Home, poi apri l'app da lì.</div>;
  }
  return (
    <div className="px-3 py-2">
      <button onClick={enable} disabled={busy} className="btn-secondary text-xs w-full justify-center" data-testid="chat-push-enable">
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Bell className="w-3.5 h-3.5" />} Attiva notifiche nuovi messaggi
      </button>
    </div>
  );
};
